import { addDeviceClasses } from './utils/add-device-classes'
import { updateFontSize } from './utils/update-font-size'
import { setScreenSize } from './utils/breakpoints'
import { wrapIframes } from "./utils/wrap-iframes"
import { initResponsiveTables } from "./utils/responsive-tables"
// import { updateSmoothScroll } from "./scroll-smoother"
import { gsap } from 'gsap'




updateFontSize()
addDeviceClasses()
wrapIframes()
initResponsiveTables()

setTimeout(function(){
  gsap.to('body', {opacity: 1})
}, 500)


$(window).on('resize', function (){

  updateFontSize()

  setScreenSize()


})


if (window.innerWidth > 1200) {
  $(document).ready(function () {

      $('.footer-spacer').css('padding-bottom', $('.desktop-footer').innerHeight())
      //updateSmoothScroll()

  })
}

